<script lang="ts">
  import { goto } from '$app/navigation';
  import { me } from '$stores/user.store';
  import type { UserDocument } from 'garden-common';
  import UserAvatarWrapper from './userAvatarWrapper.svelte';
  import type { IUser } from 'garden-common';
  import { openPostInModal } from '$src/stores';

  export let user:
    | IUser<string>
    | UserDocument
    | { _id: string; userName: string; name: string; profileImage: string };
  export let cls: string = 'w-12 h-12';
  export let username: boolean = true;
  export let name: boolean = true;
  export let nameClass = 'text-blueish-grey-900 font-medium';
  export let usernameClass = 'text-blueish-grey-600 text-sm';
  export let padding: boolean = true;
</script>

<!-- For testing -> src="https://api.dicebear.com/5.x/identicon/svg?seed=$Test&backgroundColor=ffffff" -->

<button
  on:click={() => {
    if (!user?.userName) return; // TODO check if user is deleted
    openPostInModal.set(false);
    goto(`/profile/${user?.userName}`);
  }}
  class:px-4={padding}
  class="flex flex-row gap-2 items-center justify-start pr-2"
>
  <div class="flex min-w-8">
    <UserAvatarWrapper profileImage={user?.profileImage} userName={user?.userName} {cls} />
  </div>

  <div class="flex flex-col text-left justify-between h-full">
    {#if name}<span class="{nameClass} hover:underline font-switzer">
        {user?._id == $me?._id ? 'Me' : user?.name || 'Deleted'}
      </span>{/if}
    {#if username}<span class={`${usernameClass} font-switzer`}>
        @{user?._id == $me?._id ? 'Me' : user?.userName || 'Deleted'}
      </span>{/if}
  </div>
</button>
